import * as Sentry from '@sentry/vue'

export default {
    install(app, options) {
        app.config.globalProperties.$sentry = Sentry
    }
}